// @ts-ignore
import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import SubAdminDetails from '../SubAdmins/SubAdminDetails/SubAdminDetails'
import {UsersListWrapper} from './users-list/UsersList'
import UsersDetailsPage from './UsersDetailsPage'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Users Management',
    path: '/apps/agents',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const UsersManagement = () => {
  console.log('hello')
  return (
    <Routes>
      {/* <Route element={<Outlet />}> */}
      <Route
        path='/'
        element={
          <>
            <PageTitle breadcrumbs={usersBreadcrumbs}>Users list</PageTitle>
            <UsersListWrapper />
          </>
        }
      />
      <Route
        path='/:p'
        element={
          <>
            <PageTitle breadcrumbs={usersBreadcrumbs}>Users list</PageTitle>
            <UsersListWrapper />
          </>
        }
      />
      <Route path='agents/details-page' element={<UsersDetailsPage />} />

      {/* </Route> */}
      <Route element={<Navigate to='/apps/agents' />} />
    </Routes>
  )
}

export default UsersManagement
